import firebase from "firebase";
import { OlabUtils } from "./olabutils.js";
import db from "./db.js";

class OlabCart {
  constructor(cart) {
    if (cart == null) {
      this.initCart();
    } else {
      let hp = Object.prototype.hasOwnProperty;
      this.editDisplayState = hp.call(cart, "editDisplayState")
        ? cart.editDisplayState
        : "inline";
      this.olab_id = hp.call(cart, "olab_id") ? cart.olab_id : null;
      this.olab_type = hp.call(cart, "olab_type") ? cart.olab_type : null;
      this.name = hp.call(cart, "name") ? cart.name : null;
      this.name_uc = hp.call(cart, "name_uc") ? cart.name_uc : null;
      this.creator = hp.call(cart, "creator") ? cart.creator : null;
      this.creator_uc = hp.call(cart, "creator_uc") ? cart.creator_uc : null;
      this.project_id = hp.call(cart, "project_id") ? cart.project_id : null;
      this.desc = hp.call(cart, "desc") ? cart.desc : null;
      this.design_id = hp.call(cart, "design_id") ? cart.design_id : null;
      this.design_name = hp.call(cart, "design_name") ? cart.design_name : null;
      this.comps = hp.call(cart, "comps") ? cart.comps : [];
      this.cstbs = hp.call(cart, "cstbs") ? cart.cstbs : [];
    }
  }

  static getOlabCartConverter() {
    // Firestore data converter
    let olabCartConverter = {
      toFirestore: function(cart) {
        return {
          editDisplayState: cart.editDisplayState,
          olab_id: cart.olab_id,
          olab_type: cart.olab_type,
          name: cart.name,
          name_uc: cart.name_uc,
          creator: cart.creator,
          creator_uc: cart.creator_uc,
          project_id: cart.project_id,
          desc: cart.desc,
          design_id: cart.design_id,
          design_name: cart.design_name,
          comps: cart.comps,
          cstbs: cart.cstbs
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabCart(data);
      }
    };
    return olabCartConverter;
  }

  static getCreateCartConverter() {
    // Firestore data converter
    let olabCartConverter = {
      toFirestore: function(cart) {
        return {
          editDisplayState: cart.editDisplayState,
          olab_id: cart.olab_id,
          olab_type: cart.olab_type,
          name: cart.name,
          name_uc: cart.name_uc,
          creator: cart.creator,
          creator_uc: cart.creator_uc,
          project_id: cart.project_id,
          desc: cart.desc,
          design_id: cart.design_id,
          design_name: cart.design_name,
          comps: cart.comps,
          cstbs: cart.cstbs,
          created_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabCart(data);
      }
    };
    return olabCartConverter;
  }

  static getUpdateCartConverter() {
    // Firestore data converter
    let olabCartConverter = {
      toFirestore: function(cart) {
        return {
          editDisplayState: cart.editDisplayState,
          // olab_id: cart.olab_id,
          // olab_type: cart.olab_type,
          name: cart.name,
          name_uc: cart.name_uc,
          creator: cart.creator,
          creator_uc: cart.creator_uc,
          project_id: cart.project_id,
          desc: cart.desc,
          design_id: cart.design_id,
          design_name: cart.design_name,
          comps: cart.comps,
          cstbs: cart.cstbs,
          updated_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabCart(data);
      }
    };
    return olabCartConverter;
  }

  initCart() {
    OlabUtils.infoLog("OlabCart.initCart() ...");
    // Common fields: internal use
    this.olab_id = null;
    this.olab_type = null;
    this.name_uc = null;
    this.creator_uc = null;

    // Common fields: User settable
    this.name = null;
    this.creator = null;
    this.project_id = null;
    this.desc = null;
    this.design_id = null;
    this.design_name = null;
    this.comps = [];
    this.cstbs = [];
  }

  set(cart) {
    this.olab_id = cart.olab_id;
    this.olab_type = cart.olab_type;
    this.name = cart.name;
    // append unique key to name_uc for search to work later
    if (this.name != null) {
      this.name_uc = this.name.toUpperCase() + " ^%#- " + this.olab_id;
    } else {
      this.name_uc = null;
    }
    this.creator = cart.creator;
    // append unique key to creator_uc for search to work later
    if (this.creator != null) {
      this.creator_uc = this.creator.toUpperCase() + " ^%#- " + this.olab_id;
    } else {
      this.creator_uc = null;
    }
    this.project_id = cart.project_id;
    this.desc = cart.desc;
    this.design_id = cart.design_id;
    this.design_name = cart.design_name;
    this.comps = cart.comps;
    this.cstbs = cart.cstbs;
  }

  static saveCart(cart, project) {
    const cartRef = "projects/PJ/olab_items/" + project.olab_id + "/olab_carts";
    db.collection(cartRef)
      .withConverter(OlabCart.getUpdateCartConverter())
      .doc(cart.olab_id)
      .set(cart, { merge: true })
      .then(function() {
        OlabUtils.infoLog("saveCart: Document successfully written!");
      })
      .catch(function(error) {
        OlabUtils.infoLog("saveCart: Error writing document: ", error);
        this.error = error;
      });
  }

  static infoLog(cart) {
    OlabUtils.infoLog("cart.olab_id = " + cart.olab_id);
    OlabUtils.infoLog("cart.olab_type = " + cart.olab_type);
    OlabUtils.infoLog("cart.name = " + cart.name);
    OlabUtils.infoLog("cart.name_uc = " + cart.name_uc);
    OlabUtils.infoLog("cart.creator = " + cart.creator);
    OlabUtils.infoLog("cart.creator_uc = " + cart.creator_uc);
    OlabUtils.infoLog("cart.project_id = " + cart.project_id);
    OlabUtils.infoLog("cart.desc = " + cart.desc);
    OlabUtils.infoLog("cart.design_id = " + cart.design_id);
    OlabUtils.infoLog("cart.design_name = " + cart.design_name);
    OlabUtils.infoLog("cart.comps = " + cart.comps);
    if (cart.comps !== null) {
      OlabUtils.infoLog("cart.comps = [");
      cart.comps.forEach(element => {
        OlabUtils.infoLog(
          "   olab_id = " + element.olab_id + ", qty = " + element.qty
        );
      });
      OlabUtils.infoLog("]");
    }
    OlabUtils.infoLog("cart.cstbs = " + cart.cstbs);
    if (cart.cstbs !== null) {
      OlabUtils.infoLog("cart.cstbs = [");
      cart.cstbs.forEach(element => {
        OlabUtils.infoLog(
          "   olab_id = " +
            element.olab_id +
            ", use_seq_as = " +
            element.use_seq_as
        );
      });
      OlabUtils.infoLog("]");
    }
  }
}

export { OlabCart };
